// extracted by mini-css-extract-plugin
export default {"training":"Training_training__TRKwk","container":"Training_container__EgoTw","grid":"Training_grid__fIdyp","detail":"Training_detail__FN4ix"};